export const createOrg = "Create an Organization";
export const EditOrg = "Edit Organization Details";
export const linkInput = {
  name: "OrganizationLink",
  disabled: true,
  value: "",
};
